import * as yup from 'yup'
const schema = yup.object({
  hotelSelected: yup.string().required(),
  dateRange: yup
    .object({
      start: yup.string().required(),
      end: yup.string().required(),
    })
    .required(),
})

export default schema
